import Footage from "./components/Footage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SideMenu from "./components/menu/SideMenu";
import MyAccountMenu from "./components/menu/MyAccountMenu";
import SnackBar from "./components/SnackBar";
import Spinner from "./components/Spinner";
import CookieBanner from "./components/CookieBanner.vue";
import SupportAccess from "./components/SupportAccess";

export default {
  install(Vue) {
    Vue.component("een-footage", Footage);
    Vue.component("een-header", Header);
    Vue.component("een-footer", Footer);
    Vue.component("een-side-menu", SideMenu);
    Vue.component("een-account-menu", MyAccountMenu);
    Vue.component("een-snack-bar", SnackBar);
    Vue.component("een-spinner", Spinner);
    Vue.component("een-cookie-banner", CookieBanner);
    Vue.component("een-support-access", SupportAccess);
  }
};
